export enum approvalRequiredTypes {
  none = "none",
  always = "always",
  afterLimitExceeded = "afterLimitExceeded",
}
